import React from "react";
import "../style.css";

const Footer = () => {
  return (
    <footer className="footer">
      <h3 className="contact-head">contact</h3>
      {/* <p className="contact-name">Kriss Stockhaus</p> */}
      <p className="contact-email">kriss.stockhaus@brinelinegames.se</p>
    </footer>
  );
};
export default Footer;
